/* AVRA_QUICK_ADD (2026-10-10)
   The "Add to bag" button on product cards (homepage carousels, collections,
   New Arrivals, recommendations...).

   BEFORE: it silently added the piece's FIRST variant - whatever metal, size
   and carat happened to be first - and gave no visible sign anything happened.

   NOW: it opens a small sheet for that piece:
     - photo, name, live price;
     - every option the piece has (Metal as gold swatches, Size / Length /
       Carat / Chain Length as pills). Options with a single value are chosen
       for her; anything with a real choice must be picked - nothing is
       pre-selected, so she can never end up with a size she did not choose;
     - the same confirmation box as the product page ("I confirm I have
       double checked...") - Add to Bag does nothing until it is ticked;
     - ring sizes 9+ show the final-sale line, same as the product page.
   On add: the button turns into "Added to bag" with a tick, the photo flies
   to the bag icon, the bag count pulses, and the bag drawer opens.

   Personalised pieces (tag "personalized" - name necklaces, nameplate,
   initial) need her text, so for those the button goes to the product page.

   The theme's own card handler (avra-theme.js initCart) is skipped by
   catching the click first, in the capture phase. Adding uses Shopify's
   /cart/add.js like the rest of the theme. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CONFIRM_TEXT = 'I confirm I have double checked and selected the correct options. We are unable to accept returns or exchanges for the wrong size.';
  var METALS = { 'yellow gold': 'yellow', 'white gold': 'white', 'rose gold': 'rose', 'champagne gold': 'champagne' };
  var cache = {};

  /* ---------- styles ---------- */
  var css = [
    '.aqa{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;pointer-events:none}',
    '.aqa[hidden]{display:none}',
    '.aqa__scrim{position:absolute;inset:0;background:rgba(26,24,19,.38);opacity:0;transition:opacity .3s ease;pointer-events:auto}',
    '.aqa.is-open .aqa__scrim{opacity:1}',
    '.aqa__sheet{position:relative;width:100%;max-width:460px;max-height:88vh;overflow:auto;background:#fff;color:#1a1813;border-radius:14px 14px 0 0;padding:22px 22px 24px;transform:translateY(100%);transition:transform .38s cubic-bezier(.2,.8,.2,1);pointer-events:auto;box-shadow:0 -10px 40px rgba(0,0,0,.12)}',
    '.aqa.is-open .aqa__sheet{transform:none}',
    '@media(min-width:750px){.aqa{align-items:center}.aqa__sheet{border-radius:12px;transform:translateY(24px);opacity:0;transition:transform .32s ease,opacity .32s ease}.aqa.is-open .aqa__sheet{opacity:1}}',
    '.aqa__x{position:absolute;top:10px;right:12px;width:34px;height:34px;border:0;background:none;font-size:24px;line-height:1;color:#1a1813;cursor:pointer}',
    '.aqa__top{display:flex;gap:14px;align-items:center;margin:0 34px 16px 0}',
    '.aqa__img{width:76px;height:76px;flex:0 0 76px;object-fit:cover;border-radius:6px;background:#fff}',
    '.aqa__name{margin:0 0 4px;font-family:var(--serif,"Cormorant Garamond",Georgia,serif);font-size:20px;line-height:1.2;font-weight:400}',
    '.aqa__price{margin:0;font-size:14px;letter-spacing:.04em}',
    '.aqa__group{margin:14px 0 0}',
    '.aqa__label{display:flex;justify-content:space-between;margin:0 0 8px;font-size:11px;letter-spacing:.22em;text-transform:uppercase;color:#646052}',
    '.aqa__label b{font-weight:500;letter-spacing:.08em;text-transform:none;color:#1a1813}',
    '.aqa__pills{display:flex;flex-wrap:wrap;gap:8px}',
    '.aqa__pill{min-width:44px;padding:9px 13px;border:1px solid rgba(26,24,19,.22);border-radius:999px;background:#fff;color:#1a1813;font:inherit;font-size:13px;cursor:pointer;transition:border-color .2s,background .2s,color .2s}',
    '.aqa__pill:hover{border-color:#1a1813}',
    '.aqa__pill.is-on{background:#1a1813;border-color:#1a1813;color:#fff}',
    '.aqa__pill[disabled]{opacity:.35;text-decoration:line-through;cursor:not-allowed}',
    '.aqa__sw{width:38px;height:38px;min-width:0;padding:0;border-radius:50%;border:0;box-shadow:inset 0 0 0 1px rgba(26,24,19,.14),inset 0 -4px 8px rgba(0,0,0,.1),inset 0 4px 8px rgba(255,255,255,.45)}',
    '.aqa__sw.is-on{background-color:transparent;box-shadow:inset 0 0 0 1px rgba(26,24,19,.14),0 0 0 2px #fff,0 0 0 3px rgba(26,24,19,.6)}',
    '.aqa__pill.aqa__sw--yellow,.aqa__pill.aqa__sw--yellow.is-on{background-image:linear-gradient(145deg,#F2E2AC 0%,#DCC078 46%,#C3A455 100%)}',
    '.aqa__pill.aqa__sw--white,.aqa__pill.aqa__sw--white.is-on{background-image:linear-gradient(145deg,#F5F6F8 0%,#DCDFE4 46%,#BBC0C7 100%)}',
    '.aqa__pill.aqa__sw--rose,.aqa__pill.aqa__sw--rose.is-on{background-image:linear-gradient(145deg,#F2D0BF 0%,#E0AB91 46%,#C68668 100%)}',
    '.aqa__pill.aqa__sw--champagne,.aqa__pill.aqa__sw--champagne.is-on{background-image:linear-gradient(145deg,#F4E8D5 0%,#DFCDAF 46%,#C5B08D 100%)}',
    '.aqa__confirm{display:flex;gap:10px;align-items:flex-start;margin:18px 0 0;font-size:12.5px;line-height:1.55;color:#646052;cursor:pointer}',
    '.aqa__confirm input{flex:0 0 auto;width:17px;height:17px;margin:1px 0 0;accent-color:#1a1813;cursor:pointer}',
    '.aqa__confirm.is-warn{color:#a3392f}',
    '.aqa__note{margin:10px 0 0;font-size:12.5px;line-height:1.55;color:#a3392f}',
    '.aqa__msg{min-height:0;margin:10px 0 0;font-size:12.5px;color:#a3392f}',
    '.aqa__msg:empty{display:none}',
    '.aqa__add{position:relative;width:100%;margin:16px 0 0;padding:15px 18px;border:0;border-radius:999px;background:#1a1813;color:#fff;font:inherit;font-size:12.5px;letter-spacing:.22em;text-transform:uppercase;cursor:pointer;overflow:hidden;transition:background .3s ease,opacity .2s}',
    '.aqa__add.is-wait{opacity:.45}',
    '.aqa__add.is-busy{pointer-events:none}',
    '.aqa__add.is-done{background:#2f4a3a}',
    '.aqa__tick{display:inline-block;width:14px;height:14px;margin-right:8px;vertical-align:-2px}',
    '.aqa__tick path{stroke-dasharray:24;stroke-dashoffset:24;animation:aqaTick .45s .05s ease forwards}',
    '@keyframes aqaTick{to{stroke-dashoffset:0}}',
    '.aqa__more{display:block;margin:12px 0 0;text-align:center;font-size:12px;letter-spacing:.06em;color:#646052;text-decoration:underline;text-underline-offset:3px}',
    '.aqa-fly{position:fixed;z-index:2147483600;border-radius:8px;object-fit:cover;pointer-events:none;box-shadow:0 8px 24px rgba(0,0,0,.18);transition:transform .75s cubic-bezier(.5,-.1,.3,1),opacity .75s ease}',
    '@keyframes aqaBump{0%{transform:scale(1)}35%{transform:scale(1.35)}70%{transform:scale(.92)}100%{transform:scale(1)}}',
    '.aqa-bump{animation:aqaBump .6s ease}',
    '.prod__quick.is-added{background:#2f4a3a!important;color:#fff!important;border-color:#2f4a3a!important}'
  ].join('\n');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* ---------- helpers ---------- */
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function metalTone(v) {
    var k = String(v).toLowerCase().trim().replace(/^14k\s+/, '');
    return METALS[k] || '';
  }
  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }

  /* ---------- the sheet ---------- */
  var el = null, state = null;

  function build() {
    el = document.createElement('div');
    el.className = 'aqa';
    el.hidden = true;
    el.innerHTML = '<div class="aqa__scrim" data-aqa-close></div>' +
      '<div class="aqa__sheet" role="dialog" aria-modal="true" aria-labelledby="aqa-name">' +
      '<button type="button" class="aqa__x" data-aqa-close aria-label="Close">&times;</button>' +
      '<div data-aqa-body></div></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-aqa-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el && !el.hidden) close();
    });
  }

  function open(product, card) {
    if (!el) build();
    var groups = product.options.map(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      var values = typeof o === 'string' ? [] : o.values;
      if (!values.length) {
        values = [];
        product.variants.forEach(function (v) { var x = v.options[i]; if (values.indexOf(x) === -1) values.push(x); });
      }
      var metal = values.every(function (v) { return !!metalTone(v); });
      return { name: name, values: values, metal: metal, sel: values.length === 1 ? values[0] : null };
    });
    if (product.variants.length === 1 && groups.length === 1 && /title/i.test(groups[0].name)) groups = [];
    state = { product: product, groups: groups, card: card, variant: null };

    var img = product.featured_image || (product.images && product.images[0]) || '';
    var html = '<div class="aqa__top">' +
      (img ? '<img class="aqa__img" data-aqa-img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="">' : '') +
      '<div><p class="aqa__name" id="aqa-name">' + esc(product.title) + '</p><p class="aqa__price" data-aqa-price></p></div></div>';
    groups.forEach(function (g, gi) {
      html += '<div class="aqa__group"><p class="aqa__label"><span>' + esc(g.name) + '</span><b data-aqa-chosen="' + gi + '">' + (g.sel ? esc(g.sel) : '') + '</b></p><div class="aqa__pills" role="radiogroup" aria-label="' + esc(g.name) + '">';
      g.values.forEach(function (v) {
        var on = g.sel === v ? ' is-on' : '';
        if (g.metal) {
          html += '<button type="button" class="aqa__pill aqa__sw aqa__sw--' + metalTone(v) + on + '" data-aqa-g="' + gi + '" data-aqa-v="' + esc(v) + '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '" aria-label="' + esc(v) + '" title="' + esc(v) + '"></button>';
        } else {
          html += '<button type="button" class="aqa__pill' + on + '" data-aqa-g="' + gi + '" data-aqa-v="' + esc(v) + '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '">' + esc(v) + '</button>';
        }
      });
      html += '</div></div>';
    });
    html += '<p class="aqa__note" data-aqa-final hidden><strong>Final sale.</strong> Ring sizes 9 and up are special order and cannot be returned or exchanged.</p>' +
      '<label class="aqa__confirm" data-aqa-confirmwrap><input type="checkbox" data-aqa-confirm><span>' + CONFIRM_TEXT + '</span></label>' +
      '<p class="aqa__msg" data-aqa-msg role="alert"></p>' +
      '<button type="button" class="aqa__add" data-aqa-add>Add to bag</button>' +
      '<a class="aqa__more" href="' + esc(product.url || (ROOT + 'products/' + product.handle)) + '">View full details</a>';
    el.querySelector('[data-aqa-body]').innerHTML = html;

    el.querySelectorAll('[data-aqa-g]').forEach(function (b) {
      b.addEventListener('click', function () { pick(+b.getAttribute('data-aqa-g'), b.getAttribute('data-aqa-v')); });
    });
    el.querySelector('[data-aqa-confirm]').addEventListener('change', function () {
      el.querySelector('[data-aqa-confirmwrap]').classList.remove('is-warn');
      el.querySelector('[data-aqa-msg]').textContent = '';
      refresh();
    });
    el.querySelector('[data-aqa-add]').addEventListener('click', add);

    refresh();
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    void el.offsetWidth; /* commit the closed state first so the slide-in animates */
    el.classList.add('is-open');
    var first = el.querySelector('.aqa__pill:not(.is-on)') || el.querySelector('[data-aqa-confirm]');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
  }

  function close() {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { el.hidden = true; }, 380);
  }

  function pick(gi, value) {
    var g = state.groups[gi];
    g.sel = value;
    el.querySelectorAll('[data-aqa-g="' + gi + '"]').forEach(function (b) {
      var on = b.getAttribute('data-aqa-v') === value;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var c = el.querySelector('[data-aqa-chosen="' + gi + '"]');
    if (c) c.textContent = value;
    el.querySelector('[data-aqa-msg]').textContent = '';
    refresh();
  }

  function findVariant() {
    var p = state.product;
    if (!state.groups.length) return p.variants[0];
    if (state.groups.some(function (g) { return !g.sel; })) return null;
    return p.variants.filter(function (v) {
      return state.groups.every(function (g, i) { return v.options[i] === g.sel; });
    })[0] || null;
  }

  function refresh() {
    var p = state.product;
    var v = findVariant();
    state.variant = v;

    /* grey out values that do not exist / are sold out with the other picks */
    state.groups.forEach(function (g, gi) {
      el.querySelectorAll('[data-aqa-g="' + gi + '"]').forEach(function (b) {
        var val = b.getAttribute('data-aqa-v');
        var ok = p.variants.some(function (x) {
          return x.available && x.options[gi] === val && state.groups.every(function (o, oi) { return oi === gi || !o.sel || x.options[oi] === o.sel; });
        });
        b.disabled = !ok;
      });
    });

    var priceEl = el.querySelector('[data-aqa-price]');
    priceEl.textContent = v ? money(v.price) : (p.price_varies ? 'From ' + money(p.price_min) : money(p.price));

    if (v && v.featured_image && v.featured_image.src) {
      var im = el.querySelector('[data-aqa-img]');
      if (im) im.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
    }

    var ring = state.groups.filter(function (g) { return /ring size/i.test(g.name); })[0];
    el.querySelector('[data-aqa-final]').hidden = !(ring && ring.sel && parseFloat(ring.sel) >= 9);

    var btn = el.querySelector('[data-aqa-add]');
    var missing = state.groups.filter(function (g) { return !g.sel; })[0];
    var confirmed = el.querySelector('[data-aqa-confirm]').checked;
    if (missing) btn.textContent = 'Select ' + missing.name;
    else if (!v || !v.available) btn.textContent = 'Sold out';
    else btn.textContent = 'Add to bag';
    btn.classList.toggle('is-wait', !!missing || !v || !v.available || !confirmed);
  }

  function add() {
    var btn = el.querySelector('[data-aqa-add]');
    var msg = el.querySelector('[data-aqa-msg]');
    var missing = state.groups.filter(function (g) { return !g.sel; })[0];
    if (missing) { msg.textContent = 'Please choose your ' + missing.name.toLowerCase() + '.'; return; }
    var v = state.variant;
    if (!v || !v.available) { msg.textContent = 'This combination is sold out.'; return; }
    var box = el.querySelector('[data-aqa-confirm]');
    if (!box.checked) {
      el.querySelector('[data-aqa-confirmwrap]').classList.add('is-warn');
      msg.textContent = 'Please tick the box above to continue.';
      box.focus();
      return;
    }
    btn.classList.add('is-busy');
    btn.textContent = 'Adding…';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res.ok) { msg.textContent = (res.j && (res.j.description || res.j.message)) || 'This piece could not be added.'; refresh(); return; }
        success(btn);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        msg.textContent = 'Something went wrong. Please try again.';
        refresh();
      });
  }

  function success(btn) {
    btn.classList.add('is-done');
    btn.innerHTML = '<svg class="aqa__tick" viewBox="0 0 16 16" aria-hidden="true"><path d="M2.5 8.5l3.5 3.5 7.5-8" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Added to bag';

    var cardBtn = state.card && state.card.querySelector('.prod__quick');
    if (cardBtn) {
      var orig = cardBtn.textContent;
      cardBtn.classList.add('is-added');
      cardBtn.textContent = 'Added ✓';
      setTimeout(function () { cardBtn.classList.remove('is-added'); cardBtn.textContent = orig; }, 2600);
    }

    fly();
    setTimeout(function () {
      close();
      var bag = visibleBag();
      if (bag) bag.click(); /* opens the bag drawer and refreshes the count */
      setTimeout(bump, 250);
    }, 900);
  }

  function visibleBag() {
    var list = Array.prototype.slice.call(document.querySelectorAll('[data-bag-open]'));
    return list.filter(function (b) { return b.offsetParent !== null; })[0] || list[0] || null;
  }

  function fly() {
    var src = el.querySelector('[data-aqa-img]');
    var bag = visibleBag();
    if (!src || !bag) return;
    var a = src.getBoundingClientRect(), b = bag.getBoundingClientRect();
    var f = src.cloneNode();
    f.className = 'aqa-fly';
    f.style.left = a.left + 'px'; f.style.top = a.top + 'px';
    f.style.width = a.width + 'px'; f.style.height = a.height + 'px';
    document.body.appendChild(f);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    void f.offsetWidth;
    f.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.12)';
    f.style.opacity = '.2';
    setTimeout(function () { f.remove(); }, 800);
  }

  function bump() {
    document.querySelectorAll('[data-cart-n], [data-bag-open]').forEach(function (n) {
      if (n.offsetParent === null) return;
      n.classList.remove('aqa-bump'); void n.offsetWidth; n.classList.add('aqa-bump');
    });
  }

  /* ---------- intercept the card button before the theme's handler ---------- */
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var card = b.closest('.prod');
    var handle = card && card.getAttribute('data-product-handle');
    if (!handle) return;
    var orig = b.textContent;
    b.textContent = '…';
    getProduct(handle).then(function (p) {
      b.textContent = orig;
      var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      if (tags.indexOf('personalized') > -1 || tags.indexOf('personalised') > -1 || tags.indexOf('engravable') > -1) {
        window.location.href = p.url || (ROOT + 'products/' + handle);
        return;
      }
      open(p, card);
    }).catch(function () {
      b.textContent = orig;
      window.location.href = ROOT + 'products/' + handle;
    });
  }, true);
})();
